module.exports = __webpack_public_path__ + "static/media/new_tab.06748620.svg";